import "./experince.scss";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Timeline from "./Timeline.jsx";
const Experince = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div className="aboutmaindiv" id="experince">
      <p className="heading">
        WORK <span style={{ color: "red" }}> EXPERIENCE</span>
      </p>
      <div className="aboutContent">
        <div
          data-aos="fade-up"
          data-aos-anchor-placement="center-bottom"
          data-aos-duration="1200"
          className="aboutGif"
        >
          {/* src="./homeImage.png" */}
          {/* <img src="./homeImage.png"alt="about" /> */}
          {/* <img src="https://img.favpng.com/12/22/25/web-development-programmer-software-development-software-developer-computer-software-png-favpng-Z3dPn4z7P67KZehEDkJph8Hqi.jpg" alt="" /> */}
          <img
            src="https://cdni.iconscout.com/illustration/premium/thumb/software-development-11538049-9395582.png"
            alt="About"
          />
        </div>
        <div
          data-aos="fade-up"
          data-aos-anchor-placement="center-bottom"
          data-aos-duration="1200"
          className="aboutInfo"
        >
          <ul className="aboutInfoUl">
            <li
              data-aos="fade-up"
              data-aos-anchor-placement="center-bottom"
              data-aos-duration="1100"
              className="aboutInfoli"
            >
              <Timeline />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Experince;
